export default {
  effects: {
    captions: {
      blur: 'Desenfocar',
      crop: 'Recortar',
      enhance: 'Mejorar',
      flip: 'Voltear',
      grayscale: 'Escala de grises',
      invert: 'Invertir',
      mirror: 'Reflejar',
      rotate: 'Rotar',
      sharp: 'Nitidez',
    },
    apply: 'Aplicar',
  },
}
